import React from 'react';

export const ProductSkeleton: React.FC = () => (
  <div
    aria-hidden="true"
    className="bg-card-bg border border-card-border rounded-xl shadow-card overflow-hidden flex flex-col"
  >
    <div className="w-full aspect-[4/3] skeleton-shimmer" />
    <div className="p-4 flex flex-col flex-grow space-y-3">
      <div className="flex justify-between items-start">
        <div className="w-2/3 h-6 skeleton-shimmer rounded" />
        <div className="w-1/4 h-6 skeleton-shimmer rounded" />
      </div>
      <div className="w-1/3 h-4 skeleton-shimmer rounded" />
      <div className="space-y-2 flex-grow">
        <div className="w-full h-3 skeleton-shimmer rounded" />
        <div className="w-5/6 h-3 skeleton-shimmer rounded" />
        <div className="w-4/6 h-3 skeleton-shimmer rounded" />
      </div>
      <div className="border-t border-divider pt-3 mt-auto space-y-2">
        <div className="w-1/2 h-4 skeleton-shimmer rounded" />
        <div className="w-full h-10 skeleton-shimmer rounded-lg" />
      </div>
    </div>
  </div>
);

export const ProductListSkeleton: React.FC<{ count?: number }> = ({ count = 8 }) => (
  <div
    role="status"
    aria-live="polite"
    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6 mt-6"
  >
    <span className="sr-only">Loading products…</span>
    {Array.from({ length: count }).map((_, i) => (
      <ProductSkeleton key={i} />
    ))}
  </div>
);
